// extracted by mini-css-extract-plugin
export var container = "AboutSection-module--container--JmWe8";
export var eggContainer = "AboutSection-module--egg-container--Iwsu4";
export var eggVerticalContainer = "AboutSection-module--egg-vertical-container--093C+";
export var egg = "AboutSection-module--egg--nqxcM";
export var eggVertical = "AboutSection-module--egg-vertical--2pq4I";
export var image = "AboutSection-module--image--5VzDl";
export var contentContainer = "AboutSection-module--content-container--gOnJ0";